module.exports = __webpack_public_path__ + "static/media/29_A.e8c4ebd0.png";